import { useState } from "react";
import { toast } from "sonner";
import { Volume2, VolumeX } from "lucide-react";
import { saveRingSound } from "../api/settings";
import { useCall } from "../context/CallContext";
import { ru } from "../locales/ru";

export const RingSoundToggle = () => {
  const { ringSound, applyRingSound } = useCall();
  const [busy, setBusy] = useState(false);

  const toggle = async () => {
    const next = !ringSound;
    setBusy(true);
    try {
      await saveRingSound(next);
      applyRingSound(next);
      toast.success(next ? ru.calls.soundOn : ru.calls.soundOff);
    } catch {
      toast.error(ru.errors.generic);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center justify-between gap-3 bg-gray-50 rounded-2xl p-4" data-testid="ring-sound-row">
      <div className="flex items-center gap-3 min-w-0">
        <span className="bg-white rounded-full p-2 shrink-0">
          {ringSound ? <Volume2 size={16} /> : <VolumeX size={16} />}
        </span>
        <div className="min-w-0">
          <p className="font-semibold text-sm">{ru.calls.soundTitle}</p>
          <p className="text-xs text-gray-500">{ru.calls.soundDesc}</p>
        </div>
      </div>
      <button
        data-testid="ring-sound-button"
        onClick={toggle}
        disabled={busy}
        aria-pressed={ringSound}
        className={`shrink-0 w-12 h-7 rounded-full transition-colors relative ${ringSound ? "bg-black" : "bg-gray-300"} disabled:opacity-50`}
      >
        <span
          className={`absolute top-0.5 w-6 h-6 bg-white rounded-full transition-transform ${ringSound ? "translate-x-[22px]" : "translate-x-0.5"}`}
        />
      </button>
    </div>
  );
};
